import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "title-wrapper contents-title-text title-with-tooltip align-center" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["title"];
const _hoisted_4 = { class: "ma-0" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "option-ctrl-area option-btn d-flex ga-2" };
const _hoisted_7 = { class: "wh-pl" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    const _component_ListTemplateRow = _resolveComponent("ListTemplateRow");
    const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual");
    const _component_CardSection = _resolveComponent("CardSection");
    return (_openBlock(), _createBlock(_component_CardSection, { class: "operation-setting-card" }, {
        titleContent: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
                (_ctx.isStoreAndHubSelected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _cache[0] || (_cache[0] = _createTextVNode(" / ")),
                        _createVNode(_component_BarogoTooltip, null, {
                            activatorSlot: _withCtx(() => [
                                _createElementVNode("span", {
                                    title: _ctx.selectedHubName,
                                    class: "hub-name"
                                }, _toDisplayString(_ctx.selectedHubName), 9 /* TEXT, PROPS */, _hoisted_3),
                                _createElementVNode("span", null, _toDisplayString(_ctx.locales.headerStoreTitle), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString(_ctx.headerLengthInfo), 1 /* TEXT */)
                            ]),
                            tooltipMessage: _withCtx(() => [
                                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.locales.storeTooltipContent), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.headerLengthInfo), 1 /* TEXT */))
            ]),
            _createCommentVNode(" 컨트롤러(검색창/다이얼로그버튼) "),
            _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "controller", {}, undefined, true)
            ])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_data_table_virtual, {
                "model-value": _ctx.checkedList,
                class: _normalizeClass(["table brg-table brg-checkbox-table", `${_ctx.target}-list-table`]),
                "fixed-header": "",
                "show-select": "",
                "hide-default-footer": "",
                "items-per-page": -1,
                headers: _ctx.headers,
                items: _ctx.list,
                "item-key": "code",
                "item-height": "41",
                "return-object": "",
                "no-data-text": _ctx.noDataText,
                density: "compact",
                "onUpdate:modelValue": _ctx.handleUpdateModelValue
            }, {
                bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
                [`header.getFulfillmentStateToText`]: _withCtx(({ column }) => [
                    (!!column)
                        ? (_openBlock(), _createBlock(_component_BarogoTooltip, {
                            key: 0,
                            position: "right",
                            "without-icon": ""
                        }, {
                            activatorSlot: _withCtx(() => [
                                _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                            ]),
                            tooltipMessage: _withCtx(() => [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.locales.deliveryStatusTooltipContent), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                        : _createCommentVNode("v-if", true)
                ]),
                item: _withCtx((rowData) => [
                    _createVNode(_component_ListTemplateRow, {
                        target: _ctx.target,
                        "row-data": rowData
                    }, null, 8 /* PROPS */, ["target", "row-data"])
                ]),
                _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "class", "headers", "items", "no-data-text", "onUpdate:modelValue"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
